// extracted by mini-css-extract-plugin
export default {"search_box":"SearchBar_search_box__CJM2q","input_box":"SearchBar_input_box__XDeZY","search_icon":"SearchBar_search_icon__sCxi8","left_arrow":"SearchBar_left_arrow__lYIyt"};